/**
 * Invoice status DTO enum - matches backend API contract
 * Single source of truth for wire format
 */
export enum InvoiceStatusDTO {
  IN_PROGRESS = 'IN_PROGRESS',
  OPEN = 'OPEN',
  PAID = 'PAID',
  OVERDUE = 'OVERDUE',
  ERROR = 'ERROR',
}

/**
 * Type aliases for clear intent in request/response interfaces
 */
export type InvoiceStatusRequest = InvoiceStatusDTO;
export type InvoiceStatusResponse = InvoiceStatusDTO;
